var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordinates.length > 0)?_c('div',{ref:_vm.id,staticClass:"map-marker",style:(_vm.markerStyle),attrs:{"id":_vm.id},on:{"mouseover":_vm.handleMouseover,"mouseleave":_vm.handleMouseleave}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }